import ArrowBackIcon from '/public/icons/arrow-back.svg';

type ModalMobileHeaderProps = {
  title: string;
  onBack: () => void;
};

export function ModalMobileHeader({ title, onBack }: ModalMobileHeaderProps) {
  return (
    <div className="relative flex items-center justify-center">
      <button
        type="button"
        onClick={onBack}
        aria-label="Go back"
        className="md:hidden absolute left-0 flex items-center cursor-pointer"
      >
        <ArrowBackIcon viewBox="0 0 18 18" className="w-4 h-4 text-blue-300" aria-hidden />
      </button>
      <h2 className="light text-blue-900 mb-0.5 text-center max-md:!text-lg max-md:!leading-5.5 max-md:!tracking-[0.006em] max-md:mb-0">
        {title}
      </h2>
    </div>
  );
}
